import React, { Component } from 'react';
import { message } from '../../../node_modules/react-widgets/esm/PropTypes';

export default class Notifications extends Component {

    render() {
        const messages = this.props.messages;
        const statusBlue = "notifications-SuggestRule";
        const statusRed = "notifications-FailRule";

        /* ���� (��� ��������) ��� - Suggest */
        /*switch (message.status) {
            case 111:
                status = "notifications-FailRule";
                break;
        }*/

        return (
            <div class="notifications">
                {/*<ul>*/}
                {messages == null ? <div></div> : messages
                    .map((message, index) => (
                        <div class={`${message.isError ? statusRed : statusBlue}`} key={index}>
                            {message.messageText}
                        </div>
                    ))}
                {/*</ul>*/}
            </div>
        );
    }
}